import Link from "next/link";
import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import Stars from "@/components/base/Stars";
import LocationIcon from "../../../../public/images/location_ic.svg";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";


const CityCardWrapper = styled.div`
    margin:10px;
    cursor: pointer;
    position: relative;
    

    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url("${props => props.$image }");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    //border-bottom:1px solid ${getColor('grayBackground')};
    //transition: border-width 0.3s ease-in-out, transform 0.3s ease-in-out;

    &:hover::before {
        width: 100%; /* Full width on hover */
    }
    //
    // &::before {
    //     content: '';
    //     position: absolute; /* Position the border element */
    //     left: 0; /* Start from the left */
    //     bottom: -1px; /* Align to the bottom */
    //     height: 2px; /* Height of the border */
    //     background-color: ${getColor('gold')}; /* Color of the border */
    //     width: 0; /* Start with 0 width */
    //     transition: width 0.5s ease-in-out; /* Transition effect */
    // }
    
    .description{
        display: none;
    }
    .title{
        font-family: Playfair Display;
        font-size: 20px;
        color:white;
        margin-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 175px;
    }
    
    :hover{
        
    }

    .main_image{
        width:370px;
        height:370px;
        object-fit:cover;
    }
    @media only screen and (${breakpoints.mobile}) {
        .main_image {
            width: 295px;
            height: 295px;
            object-fit: cover;
        }
    }
`;

export default function CityCard({item}){
    return <ForceSSRLink prefetch={false} style={{textDecoration:'none', all:'unset'}} href={item?.slug ?? '#'}>
        <CityCardWrapper>
            <Image className={'main_image'} src={item?.homepageImage?.url} alt={item?.name} width={370} height={370}/>
            <div style={{
                "position": "absolute",
                "top": "20px",
                "left": "20px",
                "color": getColor('green'),
                "fontSize": "12px",
                "letterSpacing": "1.1px",
                "textTransform": "uppercase",
                "background": "white",
                "padding": "8px 13px"
            }}>
                NEW
            </div>

            <div style={{
                padding: '10px',
                backgroundColor:'#20382D',
            }}>

                <div
                    style={{
                        display:'flex',
                        justifyContent:'space-between',
                        alignItems:'center',
                    }}
                >
                    <div className={'title'}>{item?.name}</div>
                    <Stars numOfStars={item?.data?.homepage?.numOfStars ?? 0}/>
                </div>




                <div style={{
                    display: 'flex',
                    alignItems:'center',
                    gap: '5px',
                    color: 'white',
                }}>
                    <Image src={LocationIcon} alt={'Location'}/>
                    {item?.locationLabel}
                </div>
            </div>


        </CityCardWrapper>
    </ForceSSRLink>
}
